module.exports = __webpack_public_path__ + "static/media/landing-ico-4.b253650e.svg";